"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSameAsReverseTripWidgetConfig = void 0;
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const helpers_1 = require("../../../../utils/helpers");
const odHelpers = __importStar(require("../../../odSurvey/helpers"));
const helpers_2 = require("./helpers");
const getSameAsReverseTripWidgetConfig = (
// FIXME: Type this when there is a few more widgets implemented
options = {}) => {
    return {
        type: 'question',
        path: 'sameModeAsReverseTrip',
        inputType: 'radio',
        twoColumns: false,
        datatype: 'boolean',
        label: (t, interview, _path) => {
            var _a;
            const person = odHelpers.getPerson({ interview });
            const previousSegment = (0, helpers_2.getPreviousTripSingleSegment)({ interview, person });
            const journey = odHelpers.getActiveJourney({ interview, person });
            const trip = odHelpers.getActiveTrip({ interview, journey });
            const visitedPlaces = odHelpers.getVisitedPlaces({ journey });
            const destination = trip ? odHelpers.getDestination({ trip, visitedPlaces }) : undefined;
            const labelWithDestination = `segments:SegmentSameModeReturn${destination && destination.activity === 'home' ? 'Home' : ''}`;
            return t([`customSurvey:${labelWithDestination}`, labelWithDestination], {
                context: (_a = options.context) === null || _a === void 0 ? void 0 : _a.call(options),
                count: odHelpers.getCountOrSelfDeclared({ interview, person }),
                previousMode: previousSegment && previousSegment.mode
                    ? t([
                        `customSurvey:segments:mode:short:${previousSegment.mode}`,
                        `segments:mode:short:${previousSegment.mode}`
                    ])
                    : ''
            });
        },
        choices: [
            {
                value: true,
                label: (t) => t('survey:Yes')
            },
            {
                value: false,
                label: (t) => t('survey:No')
            }
        ],
        validations: function (value) {
            return [
                {
                    validation: (0, LodashExtensions_1._isBlank)(value),
                    errorMessage: (t) => t(['customSurvey:ResponseIsRequired', 'survey:ResponseIsRequired'])
                }
            ];
        },
        conditional: (interview, path) => {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            return [(0, helpers_2.shouldShowSameAsReverseTripQuestion)({ interview, segment }), null];
        }
    };
};
exports.getSameAsReverseTripWidgetConfig = getSameAsReverseTripWidgetConfig;
//# sourceMappingURL=widgetSameAsReverseTrip.js.map